import { withTranslation, Trans } from "next-i18next";
import { useCurrentUser } from "@hooks/use-current-user";
import isPaymentMethodValid from "@utils/isPaymentMethodValid";

function DefaultPaymentMethod({ t }) {
  const defaultPaymentMethod = useCurrentUser()?.default_payment_method;

  const displayCreditCard = () => (
    <>
      <p className="mb-0 text-capitalize text-gray">
        <Trans
          i18nKey="common:payment_method.credit_card.last4"
          values={{
            brand: defaultPaymentMethod.brand,
            last4: defaultPaymentMethod.last4,
          }}
          components={[
            <span
              className="text-dark"
              key="first"
            />,
          ]}
        />
      </p>
      <p className="mb-0 text-gray">
        <Trans
          i18nKey="common:payment_method.credit_card.expiracy"
          values={{
            month: defaultPaymentMethod.exp_month,
            year: defaultPaymentMethod.exp_year,
          }}
          components={[
            <span
              className={isPaymentMethodValid(defaultPaymentMethod) ? "text-dark" : "text-danger"}
              key="first"
            />,
          ]}
        />
      </p>
    </>
  );

  const displayPaypal = () => (
    <p className="mb-0">
      <Trans
        i18nKey="common:payment_method.paypal.owner"
        values={{
          payerEmail: defaultPaymentMethod.payer_email,
        }}
        components={[
          <span
            className="text-dark"
            key="first"
          />,
        ]}
      />
    </p>
  );

  const displayWalletCreditCard = () => (
    <>
      <p className="mb-0">{t(`common:payment_method.${defaultPaymentMethod.type}`)}</p>
      {displayCreditCard()}
    </>
  );

  const displaySepaDebit = () => {
    const last4Sliced =
      defaultPaymentMethod.last4.slice(0, 1) + " " + defaultPaymentMethod.last4.slice(1, 4);

    return (
      <p className="mb-0 text-capitalize">
        <Trans
          i18nKey="common:payment_method.sepa_debit.iban"
          values={{
            bankCode: defaultPaymentMethod.bank_code,
            last4: last4Sliced,
          }}
          components={[
            <span
              className="text-dark"
              key="first"
            />,
          ]}
        />
      </p>
    );
  };

  if (!defaultPaymentMethod) return null;

  switch (defaultPaymentMethod.type) {
    case "card":
      return displayCreditCard();
    case "paypal":
      return displayPaypal();
    case "google_pay":
      return displayWalletCreditCard();
    case "apple_pay":
      return displayWalletCreditCard();
    case "sepa_debit":
      return displaySepaDebit();
    default:
      return null;
  }
}

export default withTranslation("common")(DefaultPaymentMethod);
